export default __webpack_public_path__ + "static/media/magnifiying-glass.2b06c12f.svg";